import React from 'react'
import styled from '@emotion/styled'
import { Alert } from 'antd'
import { Link } from 'react-router-dom'
import { keyframes } from '@emotion/react'
import { useGlobalQuery } from 'hooks/useGlobalQuery'
import {
  COLLAPSED_MARGIN_LEFT,
  EXPANDED_MARGIN_LEFT
} from '../Layout/constants'

interface ExpiredCardWarningProps {
  show: boolean
}

const ExpiredCardWarning: React.FC<ExpiredCardWarningProps> = ({ show }) => {
  const { collapsed } = useGlobalQuery()

  if (!show) return null

  return (
    <StyledAlert
      message={
        <>
          Your card on file has expired. To continue transacting with Slerp,
          please update your credit card. Click{' '}
          <Link to='/settings/accounts-and-billing'>
            <strong>here</strong>
          </Link>{' '}
          to update
        </>
      }
      type='warning'
      collapsed={collapsed}
    />
  )
}

const slideDown = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const StyledAlert = styled(Alert)<{ collapsed: boolean }>`
  position: fixed;
  left: ${({ collapsed }) =>
    collapsed ? `${COLLAPSED_MARGIN_LEFT}px` : `${EXPANDED_MARGIN_LEFT + 1}px`};
  top: 0;
  z-index: 100;
  width: ${({ collapsed }) =>
    collapsed
      ? `calc(100% - ${COLLAPSED_MARGIN_LEFT}px)`
      : `calc(100% - ${EXPANDED_MARGIN_LEFT + 1}px)`};
  text-align: center;
  border: none;
  background-color: #ffe58f;
  border-radius: 0;
  border-left: 1px solid white;
  animation: ${slideDown} 150ms ease-in forwards;

  padding: 0px 16px;
  font-size: 13px;
`

export default ExpiredCardWarning
